module.exports = __webpack_public_path__ + "img/radio.46e8576f.svg";